import styles from './tituloSection.module.scss';
import cpnjLogo from '../../assets/cnpj-icon.png';
import cpfLogo from '../../assets/cpf-icon.png';
import { useEffect, useState } from 'react';
import { formatarCNPJOrCpf, isCPForCNPJ } from '../../utils/formatCNPJOrCPF';
import { BrLoading } from '@govbr-ds/react-components';
import { IIdentificacaoBasica } from '../../interfaces/IIdentificacaoBasica';
import { useQuery } from '@tanstack/react-query';
import { useBackEndRequests } from '../../pages/PrimeiroAdquirente/lib/backEndRequests';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';

interface TituloSectionProps {
  type?: string;
  isSteps?: boolean;
}

function TituloSection({ type, isSteps = false }: TituloSectionProps) {
  const [userCpfCnpj, setuserCpfCnpj] = useState<string | null>(sessionStorage.getItem('userCpfCnpj'));
  const [userMunicipio, setuserMunicipio] = useState<string | null>();
  const [userUF, setuserUF] = useState<string | null>();
  const [userNomeRazaoSocial, setuserNomeRazaoSocial] = useState<string | null>();

  const [isError404, setIsError404] = useState(false);

  const container = isSteps ? styles.containerSteps : '';

  const { getIdentificacaoBasica } = useBackEndRequests();

  const {
    data: declaranteData,
    isLoading,
    error,
  } = useQuery<IIdentificacaoBasica, IErrorWithSentryId>({
    queryKey: ['idBasicaQuery', userCpfCnpj],
    queryFn: () => getIdentificacaoBasica(userCpfCnpj || ''),
    refetchOnWindowFocus: false,
    retry: isError404,
  });

  useEffect(() => {
    setuserCpfCnpj(sessionStorage.getItem('userCpfCnpj'));
  }, []);

  useEffect(() => {
    if (declaranteData) {
      setuserMunicipio(declaranteData.municipio);
      setuserUF(declaranteData.uf);
      setuserNomeRazaoSocial(declaranteData.nomeRazaoSocial);
      sessionStorage.setItem('userNomeRazaoSocial', declaranteData.nomeRazaoSocial || '');
    } else if ((declaranteData !== undefined && !declaranteData) || error?.status === 404) {
      setIsError404(true);
    }
  }, [declaranteData, error]);

  const pageInfo = () => {
    if (type === 'titular-arrendatario') {
      return (
        <>
          <i className={`fas fa-file-alt fa-lg ${styles.iconeAzul}`}></i>
          <span className={styles.infoTitle}>Titular ou Arrendatário</span>
        </>
      );
    } else if (type === 'hasta-publica') {
      return (
        <>
          <i className={`fas fa-gavel fa-lg ${styles.iconeAmarelo}`} aria-hidden></i>
          <span className={styles.infoTitle}>Arrematação de Bem Mineral adquirido em Hasta Pública</span>
        </>
      );
    } else if (type === 'primeiro-adquirente') {
      return (
        <>
          <i className={`fas fa-hand-holding-usd fa-lg ${styles.iconeVerde}`} aria-hidden />
          <span className={styles.infoTitle}>Primeiro Adquirente</span>
        </>
      );
    } else {
      return <span className={styles.infoTitle}>Bem-vindo(a)</span>;
    }
  };

  const logo = isCPForCNPJ(userCpfCnpj || '') === 'CPF' ? cpfLogo : cpnjLogo;

  return (
    <div className={container}>
      {!isError404 && (
        <div className={styles.tituloSection}>
          <div className={styles.pageInfo}>{pageInfo()}</div>
          <div className={styles.sectionEmpresa}>
            {isLoading ? (
              <BrLoading />
            ) : (
              <>
                <img src={logo} alt='logomarca' />
                <div className={styles.text}>
                  <span className={styles.title}>{userNomeRazaoSocial}</span>
                  <span className={styles.cidade}>
                    {isCPForCNPJ(userCpfCnpj || '')} {formatarCNPJOrCpf(userCpfCnpj || '')} / {userMunicipio}-{userUF}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default TituloSection;
